var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 7.20068H19.5797",
    stroke: "#2B318A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9379 7.20032V18.4002C17.938 18.6104 17.8956 18.8184 17.8131 19.0126C17.7307 19.2067 17.6097 19.3831 17.4572 19.5317C17.3047 19.6802 17.1237 19.7981 16.9244 19.8784C16.7252 19.9588 16.5116 20.0001 16.296 20H8.08383C7.86818 20.0001 7.65463 19.9588 7.45538 19.8784C7.25612 19.7981 7.07506 19.6802 6.92257 19.5317C6.77008 19.3831 6.64915 19.2067 6.56668 19.0126C6.4842 18.8184 6.44179 18.6104 6.44189 18.4002V7.20032M8.90521 7.20032V5.59976C8.9051 5.38965 8.94749 5.18157 9.02997 4.98744C9.11245 4.7933 9.2334 4.6169 9.38589 4.46833C9.53838 4.31975 9.71944 4.20192 9.91869 4.12156C10.118 4.0412 10.3315 3.9999 10.5471 4H13.8318C14.0475 3.9999 14.261 4.0412 14.4603 4.12156C14.6596 4.20192 14.8406 4.31975 14.9931 4.46833C15.1456 4.6169 15.2665 4.7933 15.349 4.98744C15.4315 5.18157 15.4739 5.38965 15.4738 5.59976V7.20032",
    stroke: "#2B318A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 11.2002V16.0003",
    stroke: "#2B318A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8325 11.2002V16.0003",
    stroke: "#2B318A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8ba3d1623ba4d344f5dae9c00dc36c03.svg";
export { ForwardRef as ReactComponent };